import BaseAPIClient from '~/clientUtils/baseApiClient';

class PDFApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    /**
     * Calls the /api/pdf/download endpoint to download a PDF file.
     * @param payload - The payload containing refId and templateId
     * @returns PDF stream
     */
    async downloadPDF(payload: { regionId: string; layout: string; size: string }): Promise<Response> {
        return this.request({
            method: 'GET',
            url: '/api/pdf/download/candidate-posters',
            params: payload,
            headers: {
                'Content-Type': 'application/pdf',
            },
        });
    }
}

const pdfApi = new PDFApi();

export default pdfApi;
